<template>
  <PageWrapper>
    <HeroBanner
      eyebrow="Jake Ramphal"
      title="Welcome to my online playground. Im pushing pixels and will be back soon. If you’d like to connect, email me at jake@ramphal.design."
    />
  </PageWrapper>
</template>

<script>
export default {
  name: "MaintenancePage",
  components: {},
};
</script>

<style scoped></style>
